import React, { useEffect, useState } from 'react';
const RangeSlider = props => {
  const [activetIndex, setActiveIndex] = useState(props.activetIndex);
  useEffect(() => {
    window.addEventListener('resize', onResize);
  }, []);
  useEffect(() => {
    init();
  }, [props.activetIndex]);
  const init = () => {
    const slider = document.getElementById(props.name);
    if (slider) {
      slider.oninput = onSliderInput;
      updateValue(slider);
      updateValuePosition(slider);
      updateProgress(slider);
      setTicks(slider);
    }
  };
  const onSliderInput = event => {
    updateValue(event.target);
    updateValuePosition(event.target);
    updateProgress(event.target);
  };
  const updateValue = slider => {
    if (slider) {
      let value = document.getElementById(slider.dataset.valueId);
      let active = slider.value / 10;
      value.innerHTML =
        "<div class='  h-35 p-20 pr-0 min-w-60 text-transparent' style='background:" +
        props.items[active].image +
        ";background-repeat: no-repeat '>" +
        props.items[active].displayName +
        '</div>';
    }
  };
  const updateValuePosition = slider => {
    if (slider) {
      let value = document.getElementById(slider?.dataset?.valueId);
      const percent = getSliderPercent(slider);

      const sliderWidth = slider.getBoundingClientRect().width;
      const valueWidth = value.getBoundingClientRect().width;
      const handleSize = slider.dataset.handleSize;

      let left = percent * (sliderWidth - handleSize) + handleSize / 2 - valueWidth / 2;

      left = Math.min(left, sliderWidth - valueWidth);
      left = slider.value === slider.min ? 0 : left;
      value.style.left = left + 'px';
    }
  };
  const updateProgress = slider => {
    if (slider) {
      let progress = document.getElementById(slider.dataset.progressId);
      const percent = getSliderPercent(slider);
      progress.style.width = percent * 100 + '%';
    }
  };
  const getSliderPercent = slider => {
    if (slider) {
      const range = slider.max - slider.min;
      const absValue = slider.value - slider.min;
      return absValue / range;
    }
  };
  const setTicks = slider => {
    if (slider) {
      let container = document.getElementById(slider.dataset.tickId);
      container.innerHTML = '';
      const spacing = parseFloat(slider.dataset.tickStep);
      const sliderRange = slider.max - slider.min;
      const tickCount = sliderRange / spacing + 1; // +1 to account for 0

      for (let ii = 0; ii < props.items.length; ii++) {
        let tick = document.createElement('span');
        tick.className = 'tick-slider-tick';
        container.appendChild(tick);
      }
    }
  };
  const onResize = () => {
    const slider = document.getElementById(props.name);
    if (slider) updateValuePosition(slider);
  };
  return (
    <>
      <style jsx global>{`
        :root {
          --yellow: rgb(103 15 122 / 50%);
          --orange: #670f7a;
          --light-gray: #d8d8d8;
          --gray: #71738b;

          --slider-handle-size: 14px;
          --slider-handle-border-radius: 2px;
          --slider-handle-margin-top: -0px;
          --slider-track-height: 10px;
          --slider-track-border-radius: 4px;
        }

        .box.box-center:after {
          content: '';
          display: block;
          border-width: 10px 10px 0;
          border-style: solid;
          border-color: #670f7a transparent transparent;
          position: absolute;
          bottom: -10px;
          left: calc(50% - 10px);
        }
        .box.box-right:after {
          content: '';
          position: absolute;
          border-left-color: transparent;
          border-top-color: transparent;
          border-right-color: #670f7a;
          left: auto;
          right: 0;
          bottom: -10px;
          border-width: 10px;
        }
        .box.box-left:after {
          content: '';
          position: absolute;
          border-left-color: #670f7a;
          border-top-color: transparent;
          border-right-color: transparent;
          left: 0;
          right: auto;
          bottom: -10px;
          border-width: 10px;
        }
        .box {
          width: auto;
          min-width: 60px;
          min-height: 20px;
          background: #670f7a;
          color: white;
          padding: 5px;
          border-radius: 5px;
          position: relative;
          text-align: center;
          font-size: 13px;
        }
        .tick-slider {
          position: relative;
          width: 100%;
        }

        .tick-slider-value-container {
          position: relative;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .tick-slider-value {
          position: absolute;
          top: -35px;
        }

        .tick-slider-value > div {
          animation: bulge 0.3s ease-out;
        }

        .tick-slider-background,
        .tick-slider-progress,
        .tick-slider-tick-container {
          position: absolute;
          bottom: 5px;
          left: 0;

          height: var(--slider-track-height);

          pointer-events: none;

          border-radius: var(--slider-track-border-radius);

          z-index: -1;
        }

        .tick-slider-background {
          width: 100%;
          background-color: var(--light-gray);
        }

        .tick-slider-progress {
          background-color: var(--yellow);
          z-index: 12;
        }

        .tick-slider-tick-container {
          width: 100%;

          display: flex;
          justify-content: space-between;
          align-items: center;

          padding: 0 calc(var(--slider-handle-size) / 2);
        }

        .tick-slider-tick {
          width: 6px;
          height: 6px;

          border-radius: 50%;

          background-color: white;
        }

        .tick-slider-label {
          opacity: 0.85;
          transition: opacity 0.1s ease;
        }

        .tick-slider-label.hidden {
          opacity: 0;
        }

        @keyframes bulge {
          0% {
            transform: scale(1);
          }

          25% {
            transform: scale(1.1);
          }

          100% {
            transform: scale(1);
          }
        }

        /*
            
                    REMOVE SLIDER STYLE DEFAULTS
            
                */
        input[type='range'] {
          -webkit-appearance: none;

          width: 100%;
          height: 100%;

          background: transparent;
          outline: none;

          margin: 5px 0;
        }

        input[type='range']::-webkit-slider-thumb {
          -webkit-appearance: none;

          border: none;
        }

        input[type='range']:focus {
          outline: none;
        }

        input[type='range']::-moz-focus-outer {
          border: 0;
        }

        /*
            
                    HANDLE
            
                */
        input[type='range']::-webkit-slider-thumb {
          -webkit-appearance: none;

          width: var(--slider-handle-size);
          height: var(--slider-handle-size);

          background: var(--orange);

          border-radius: var(--slider-handle-border-radius);

          cursor: pointer;

          margin-top: var(--slider-handle-margin-top);

          -webkit-transform: scale(1);
          transform: scale(1);

          transition: transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        input[type='range']:hover::-webkit-slider-thumb,
        input[type='range']:focus::-webkit-slider-thumb {
          transform: scale(1.2);
        }

        input[type='range']::-moz-range-thumb {
          -webkit-appearance: none;

          width: var(--slider-handle-size);
          height: var(--slider-handle-size);

          background: var(--orange);

          border: none;
          border-radius: var(--slider-handle-border-radius);

          cursor: pointer;

          transition: transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        input[type='range']:hover::-moz-range-thumb,
        input[type='range']:focus::-moz-range-thumb {
          transform: scale(1.2);
        }

        input[type='range']::-webkit-slider-runnable-track {
          width: 100%;
          height: var(--slider-track-height);

          cursor: pointer;

          background: none;

          border-radius: var(--slider-track-border-radius);
        }

        input[type='range']::-moz-range-track {
          width: 100%;
          height: var(--slider-track-height);

          cursor: pointer;

          background: none;

          border-radius: var(--slider-track-border-radius);
        }

        input[type='range']:focus::-webkit-slider-runnable-track {
          background: none;
        }
        input[type='range']:active::-webkit-slider-runnable-track {
          background: none;
        }
      `}</style>
      <div className="tick-slider">
        <div className="tick-slider-header" />
        <div className="tick-slider-value-container">
          <div id={'weightLabelMin' + props.name} className="tick-slider-label"></div>
          <div id={'weightLabelMax' + props.name} className="tick-slider-label"></div>
          <div id={'weightValue' + props.name} className="tick-slider-value" />
        </div>
        <div className="tick-slider-background"></div>
        <div id={'weightProgress' + props.name} className="tick-slider-progress"></div>
        <div id={'weightTicks' + props.name} className="tick-slider-tick-container"></div>
        <input
          id={props.name}
          className="tick-slider-input"
          type="range"
          min="0"
          max={(props.items.length - 1) * 10}
          step="10"
          value={activetIndex * 10}
          data-tick-step="10"
          data-tick-id={'weightTicks' + props.name}
          data-value-id={'weightValue' + props.name}
          data-progress-id={'weightProgress' + props.name}
          data-handle-size="16"
          data-min-label-id={'weightLabelMin' + props.name}
          data-max-label-id={'weightLabelMax' + props.name}
          onChange={e => {
            props.change(props.name, e.target.value / 10);
            setActiveIndex(e.target.value / 10);
          }}
        />
      </div>
    </>
  );
};
export default RangeSlider;
